import CardWithImg from "./CardWithImg";
import girlwithpartybag from "../img/indian-women-holding-partybag.png";
import girlwithslingbag from "../img/girl-with-slingbag.jpg";
import girlwithtotebag from "../img/girl-with-tote.jpeg";

const MasterCardCategories = () => {

    return (
        <>
        <section class="cards-section perl" id="tax">
            <div class="container">
                <h2 class="section-title">Shop By Category</h2>

                <div class="cards-grid">
                    <CardWithImg header="Tote Bag" para="" img={girlwithtotebag} to="/totebag"/>
                    <CardWithImg header="Party Bag" para="" img={girlwithpartybag} to="/partybag"/>
                    <CardWithImg header="Sling Bag" para="" img={girlwithslingbag} to="/slingbag"/>
                </div>
            </div>
        </section>
        </>
    );
}

export default MasterCardCategories;